import { template as template_d7b752c7852c429d90332790e6dec040 } from "@ember/template-compiler";
import type { TemplateOnlyComponent } from '@ember/component/template-only';
import RouteTemplate from 'ember-route-template';
import CardError from '@cardstack/host/components/card-error';
import type { ErrorModel as IndexRouteErrorModel } from '@cardstack/host/routes/index';
interface Signature {
    Args: {
        model: IndexRouteErrorModel;
    };
}
const IndexErrorRouteComponent: TemplateOnlyComponent<Signature> = template_d7b752c7852c429d90332790e6dec040(`
  <CardError
    @type={{@model.loadType}}
    @message={{@model.message}}
    @operatorModeState={{@model.operatorModeState}}
  />
`, {
    eval () {
        return eval(arguments[0]);
    }
});
export default RouteTemplate(IndexErrorRouteComponent);
